<template>
    <div class="version-wrap">
        <ul class="list-wrap scroll-wrap">
            <li class="list-item" v-for="(item, index) in list" :key="index">
                <div class="list-item-header">
                    <span class="title">{{ item.title }}</span>
                    <span class="date">{{ item.date }}</span>
                </div>
                <div class="list-item-content">
                    <p v-for="(textItem, textIndex) in item.content" :key="textIndex">
                        {{ textItem.text }}
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "VersionHistory",
    data() {
        return {
            list: [
                {
                    title: "v1.1—版本历史更新",
                    date: "2023年12月12日",
                    content: [
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                    ],
                },
                {
                    title: "v1.1—版本历史更新",
                    date: "2023年12月12日",
                    content: [
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                    ],
                },
                {
                    title: "v1.1—版本历史更新",
                    date: "2023年12月12日",
                    content: [
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                    ],
                },
                {
                    title: "v1.1—版本历史更新",
                    date: "2023年12月12日",
                    content: [
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                        {
                            text: "版本更新了，快来体验吧",
                        },
                    ],
                },
            ],
        };
    },
    created() {
        this.$nextTick(() => {
            const content = document.querySelector('.scroll-wrap')
            let scrollTimeout = null;
            content.classList.add('hide-scrollbar');

            content.addEventListener('scroll', function () {
                content.classList.remove('hide-scrollbar');
                // 清除已经设置的延迟执行的隐藏滚动条的函数
                clearTimeout(scrollTimeout);

                // 延迟一段时间（例如1000毫秒）后隐藏滚动条
                scrollTimeout = setTimeout(function () {
                    content.classList.add('hide-scrollbar');
                }, 1000);
            });
        })

    }
};
</script>
<style lang="scss" scoped>
.version-wrap {
    padding: 14px 0;
    height: calc(100%);
    display: flex;
    position: relative;

    &::after {
        content: "";
        position: absolute;
        left: -10px;
        right: -10px;
        bottom: -10px;
        height: 16px;
        opacity: 1;
        border-radius: 0px 0px 8px 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.08);
    }

    .list-wrap {
        margin: 0 auto;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0 36px;

        .list-item {
            width: 520px;
            border-radius: 8px;
            padding: 16px;
            background: rgba(255, 255, 255, 0.04);
            border: 1px solid rgba(232, 232, 232, 1);
            margin-bottom: 24px;

            .list-item-header {
                display: flex;
                justify-content: space-between;
                height: 24px;
                line-height: 24px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);

                .title {
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(51, 51, 51, 1);
                }
            }

            .list-item-content {
                margin-top: 8px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
            }
        }
    }



    .list-wrap::-webkit-scrollbar {
        width: 4px;
        height: 100px;
        background-color: rgba(0, 0, 0, 0);
    }

    .list-wrap::-webkit-scrollbar-track {
        margin-top: 147px;
        margin-bottom: 186px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.08);
    }

    .list-wrap::-webkit-scrollbar-thumb {
        height: 50%;
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 4px;
    }

    .hide-scrollbar::-webkit-scrollbar {
        display: none;
    }
}
</style>
